module.exports = __webpack_public_path__ + "img/circle_num_1_red.0fbba6fd.svg";